module.exports = ionic;


//////////////////
// WEBPACK FOOTER
// external "ionic"
// module id = 492
// module chunks = 0